import {
  alpha,
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../componentes/notificationProvider";
import api from "../../services/api";
import NewAlertModal from "../../componentes/newAlertModal";
import { Add, Cached, Clear, Search, Upload } from "@mui/icons-material";
import LoadingPage from "../../componentes/loadingPage";
import CadastroTable from "./cadastroTable";
import FormHostModal from "./modalFormHost";
import Papa from "papaparse";
import { v4 as uuidv4 } from "uuid";

const styless = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },

  tabs: {
    pt: 1,
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      borderRadius: "5px 5px 0 0",
      p: 0.2,
    },
    "& button": {
      textTransform: "none",
    },

    borderBottom: 1,
    borderColor: "divider",
    backgroundColor: "transparent",

    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: 2.5,
    },
    "& button.Mui-selected": {
      backgroundColor: "transparent",
    },
  },
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
  },
  boxTab: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
  },
  boxLoading: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "500px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
  },

  textField: {
    width: "100%",
    maxWidth: 500,
  },
});

export default function EasyAdd({ socket }) {
  const [pageValue, setPageValue] = useState("cadastrados");
  const [hostsCadastrados, setHostsCadastrados] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [proxys, setProxys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [buscarHost, setBuscarHost] = useState("");

  const [openCreateHostModal, setOpenCreateHostModal] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [confirmLoad, setConfirmLoad] = useState(false);
  const [hostToDelete, setHostToDelete] = useState(null);
  const [editingHostData, setEditingHostData] = useState(null);
  const theme = useTheme();
  const styles = styless(theme);
  const navigate = useNavigate();
  const notify = useNotification();
  const modalFormHostRef = useRef();
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = () => {
    apiGetHostsCadastrados();
    apiGetTemplates();
    apitGetProxys();
  };

  async function apiGetHostsCadastrados() {
    setLoading(true);
    try {
      const response = await api.get("/easyAdd/zabbix/hosts");
      if (response?.data) {
        setHostsCadastrados(response?.data);
      }
    } catch (error) {
      console.error(error);
      notify(
        error?.response?.data?.message || "Erro ao buscar hosts cadastrados",
        "error",
      );
    } finally {
      setLoading(false);
    }
  }

  async function apiGetTemplates() {
    try {
      const response = await api.get("/predefinicoes/findMany");
      setTemplates(response?.data || []);
    } catch (error) {
      console.error(error);
      notify(
        error?.response?.data?.message || "Erro ao buscar predefinições",
        "error",
      );
    }
  }

  async function apitGetProxys(params) {
    try {
      const reponse = await api.get("/easyAdd/zabbix/proxys", { params });
      setProxys(reponse?.data);
    } catch (error) {
      console.error(error);
      notify(
        `Error:${error?.response?.data?.error || "Ao buscar os proxys"} `,
        "error",
      );
    }
  }
  async function createHost(host) {
    try {
      setLoadingCreate(true);
      const response = await api.post("easyAdd/zabbix/createHost", {
        hostData: host,
      });
      if (response.data.error) {
        const error = response.data.error;
        notify(
          `Erro ao criar host: ${error.code} - ${error.data}`,
          "error",
          5000,
        );
        return;
      }
      const hostid = response?.data?.data;
      host.id = hostid;
      let newHosts = [...hostsCadastrados];
      host.checks = {
        ping: host?.statusPing,
        snmp: host?.statusSnmp,
        ssh: null,
      };

      newHosts.push(host);
      setHostsCadastrados(newHosts);
      modalFormHostRef?.current?.close();

      notify("Host criado com sucesso.", "success");
    } catch (error) {
      console.error(error);
      notify(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Erro ao criar host.",
        "error",
      );
    } finally {
      setLoadingCreate(false);
    }
  }

  async function updateHost(host, hostFormatted) {
    try {
      setLoadingCreate(true);
      const response = await api.put("easyAdd/zabbix/updateHost", {
        hostData: host,
      });
      if (response.data.error) {
        const error = response.data.error;
        notify(
          `Erro ao atualizar host: ${error.code} - ${error.data}`,
          "error",
          5000,
        );
        return;
      }
      let newHosts = [...hostsCadastrados];
      const index = newHosts.findIndex((h) => h.id === host.hostId);

      if (index !== -1) {
        newHosts[index] = hostFormatted;
        newHosts[index].checks = {
          ping: host?.statusPing,
          snmp: host?.statusSnmp,
          ssh: null,
        };
      }
      setHostsCadastrados(newHosts);
      modalFormHostRef?.current?.close();

      notify("Host atualizado com sucesso.", "success");
    } catch (error) {
      console.error(error);
      notify(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Erro ao atualizar host.",
        "error",
      );
    } finally {
      setLoadingCreate(false);
    }
  }

  const handleRequestDelete = (hostId) => {
    setHostToDelete(hostId);
    setOpenModalConfirmacao(true);
  };

  async function deleteHost() {
    if (!hostToDelete) return;

    try {
      setOpenModalConfirmacao(false);
      setConfirmLoad(true);
      await api.delete("easyAdd/zabbix/deleteHost", {
        data: { id: hostToDelete },
      });

      let newHosts = [...hostsCadastrados];
      newHosts = newHosts.filter(
        (host) => (host.hostId || host.id) !== hostToDelete,
      );
      setHostsCadastrados(newHosts);

      notify("Host excluído com sucesso.", "success");
      setHostToDelete(null);
    } catch (error) {
      console.error(error);
      notify("Erro ao excluir host.", "error");
    } finally {
      setConfirmLoad(false);
    }
  }
  const stylesChips = (severity) => ({
    backgroundColor: alpha(theme.palette[severity].main, 0.2),
    color:
      theme.palette.mode === "dark"
        ? theme.palette[severity].light
        : theme.palette[severity].dark,
    fontWeight: "bold",
    "&.MuiChip-root": { borderRadius: 1 },
    "&.MuiChip-root .MuiChip-label": { marginTop: "2px" },
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: "greedy",
      encoding: "UTF-8",
      complete: (results) => {
        const data = results.data.map((row) => ({
          ...row,
          _errors: {},
          Status: {
            ping: null,
            snmp: null,
            ssh: null,
            telnet: null,
          },
          id: uuidv4(),
        }));
        navigate("/easyAdd/hosts", { state: { initialCsvData: data } });
        e.target.value = null;
      },
      error: (error) => {
        notify("Erro ao ler o arquivo CSV", "error");
      },
    });
  };
  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: { xs: 1.5, md: 1 },
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          backgroundColor: theme.palette.background.paper,
          padding: 1.5,
          borderRadius: 1,
        }}
      >
        <TextField
          id={"host-search"}
          size="small"
          placeholder="Buscar por host"
          value={buscarHost}
          onChange={(event) => setBuscarHost(event.target?.value)}
          sx={styles.textField}
          autoComplete="off"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: buscarHost ? (
              <InputAdornment position="end">
                <IconButton onClick={() => setBuscarHost("")}>
                  <Clear fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />

        <Box sx={{ display: "flex", gap: 1 }}>
          <input
            type="file"
            accept=".csv"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <Button
            startIcon={<Upload />}
            variant="outlined"
            sx={{
              color: theme.palette.text.main,
              borderColor: theme.palette.text.main,
            }}
            onClick={() => fileInputRef.current.click()}
            disabled={loading}
          >
            Importar CSV
          </Button>
          <Button
            startIcon={<Add />}
            variant="contained"
            sx={{
              color: theme.palette.text.main,
              borderColor: theme.palette.text.main,
            }}
            onClick={() => setOpenCreateHostModal(true)}
            disabled={loading}
          >
            Novo
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={loading}
            onClick={() => fetchAllData()}
            sx={{
              ...styles.buttonRefresh,
              "& .rotating": {
                animation: "spin 1s linear infinite",
              },
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(0deg)",
                },
                "100%": {
                  transform: "rotate(-360deg)",
                },
              },
            }}
          >
            <Cached
              fontSize="small"
              sx={{ color: theme.palette.text.main }}
              className={loading ? "rotating" : ""}
            />
          </Button>
        </Box>
      </Box>

      <Tabs
        textColor="inherit"
        onChange={(event, newValue) => {
          setPageValue(newValue);
        }}
        sx={styles.tabs}
        value={pageValue}
      >
        <Tab
          label={
            <Box sx={styles.boxTab}>
              Hosts Cadastrados
              <Chip
                label={loading ? 0 : hostsCadastrados?.length || 0}
                size="small"
                sx={stylesChips("success")}
              />
            </Box>
          }
          value={"cadastrados"}
          sx={{ p: 0 }}
        />
      </Tabs>

      {loading ? (
        <Box sx={styles.boxLoading}>
          <LoadingPage mt={"5%"} />
        </Box>
      ) : (
        <CadastroTable
          hostsCadastrados={hostsCadastrados ?? []}
          templates={templates}
          setOpenEditHostModal={setOpenCreateHostModal}
          setEditingHostData={setEditingHostData}
          handleRequestDelete={handleRequestDelete}
          proxys={proxys}
          buscarHost={buscarHost}
          loadingTable={confirmLoad}
        />
      )}

      <FormHostModal
        ref={modalFormHostRef}
        open={openCreateHostModal}
        onClose={() => setOpenCreateHostModal(false)}
        onSave={editingHostData ? updateHost : createHost}
        templates={templates}
        loading={loadingCreate}
        proxys={proxys}
        hostData={editingHostData}
        setEditingHostData={setEditingHostData}
      />

      <NewAlertModal
        openModal={openModalConfirmacao}
        setOpenModal={setOpenModalConfirmacao}
        textContent={"Tem certeza que deseja excluir o host?"}
        handleButton={() => {
          deleteHost();
        }}
        severity={"error"}
        singleButton={false}
      />
    </Box>
  );
}
